import { Component, input } from '@angular/core';

@Component({
    selector: 'app-inner-html',
    imports: [],
    template: `<span [innerHTML]="content()" [className]="styleClass()"></span>`,
    host: { ngSkipHydration: '' }
})
export class InnerHTMLComponent {
    content = input.required<string>();
    styleClass = input<string>();
}
